<ion-header>
  <ion-toolbar>
    <ion-title>Verify</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="dismiss()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form [formGroup]="form" novalidate>
    <div style="text-align: center;">
      <img style="max-height: 25px;" [src]="logo" alt="Logo">
    </div>

    <ion-text color="primary" class="ion-text-center">
      <h2 style="margin-bottom: 2px; ">Verify</h2>
    </ion-text>

    <ion-card>
      <ion-card-content style="padding: 5px;">
        Verification code has been sent to your entered email.
      </ion-card-content>
    </ion-card>

    <ion-list class="ion-padding" style="padding-top: 2px;">
      <ion-item>
        <ion-input
          labelPlacement="floating"
          formControlName="code"
          name="Code"
          type="number">
          <div slot="label">Code <ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>

      <ion-button
        type="submit"
        expand="block"
        color="primary"
        (click)="verify()"
        [disabled]="isVerifying"
        style="margin-top: 10px;">
        <span *ngIf="!isVerifying">Verify</span>
        <ion-spinner *ngIf="isVerifying" name="circular"></ion-spinner>
      </ion-button>

      <ion-button
        type="button"
        expand="block"
        fill="clear"
        (click)="resendOTP()"
        [disabled]="isResending"
        style="margin-top: 5px; --color: rgb(63, 81, 181);">
        <span *ngIf="!isResending">Resend OTP</span>
        <ion-spinner *ngIf="isResending" name="circular"></ion-spinner>
      </ion-button>


    </ion-list>
  </form>

  <ion-card style="margin-top: 2px;">
    <ion-card-content style="padding: 5px;">
      If you have trouble verifying your phone number please reach out to us.
      Make sure to include your name and phone number.
      <ion-button routerLink="/feedback" expand="block" fill="clear">
        Contact us
      </ion-button>
    </ion-card-content>
  </ion-card>
</ion-content>